export const CLEAR_RESULTS = 'fulcrum/Entity/CLEAR_RESULTS'
export const CLEAR_ENTITIES = 'fulcrum/Entity/CLEAR_ENTITIES'
export const UPDATE_RESULTS = 'fulcrum/Entity/UPDATE_RESULTS'
export const UPDATE_ENTITIES = 'fulcrum/Entity/UPDATE_ENTITIES'
export const UPDATE_TABLES = 'fulcrum/Entity/UPDATE_TABLES'
export const REMOVE_ENTITIES = 'fulcrum/Entity/REMOVE_ENTITIES'
export const REMOVE_RESULTS = 'fulcrum/Entity/REMOVE_RESULTS'
export const REMOVE_TABLES = 'fulcrum/Entity/REMOVE_TABLES'
export const REMOVE_ROW = 'fulcrum/Entity/REMOVE_ROW'
export const REMOVE_ENTITY_ROW = 'fulcrum/Entity/REMOVE_ENTITY_ROW'
export const REMOVE_RESULT_ROW = 'fulcrum/Entity/REMOVE_RESULT_ROW'
export const OVERWRITE_ENTITIES = 'fulcrum/Entity/OVERWRITE_ENTITIES'
export const OVERWRITE_RESULTS = 'fulcrum/Entity/OVERWRITE_RESULTS'
export const OVERWRITE_TABLES = 'fulcrum/Entity/OVERWRITE_TABLES'